export const Size = {
  "4xs": "0.5rem", // 8px
  "3xs": "0.75rem", // 12px
  "2xs": "0.875rem", // 14px
  xs: "1rem", // 16px
  sm: "1.125rem", // 18px
  md: "1.25rem", // 20px
  lg: "1.5rem", // 24px
  xl: "1.875rem", // 30px
  "2xl": "2.25rem", // 36px
  "3xl": "3rem", // 48px
  "4xl": "3.75rem", // 60px
  "5xl": "4.5rem", // 72px
  "6xl": "6rem", // 96px
};

export const Weight = {
  hairline: 100,
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900,
};

export const Family = {
  sans: "sans-serif",
  serif: "serif",
  mono: "monospace",
  display: "Oswald",
  body: "Open Sans",
};

export const LineHeight = {
  none: 1,
  tight: 1.25,
  snug: 1.375,
  normal: 1.5,
  relaxed: 1.625,
  loose: 2,
};

export const LetterSpacing = {
  tighter: "-0.05em",
  tight: "-0.025em",
  normal: "0",
  wide: "0.025em",
  wider: "0.05em",
  widest: "0.1em",
};

export const Fonts = {
  Size,
  Weight,
  Family,
  LineHeight,
  LetterSpacing,
};
